import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import tw from 'tailwind.macro';

// Components
import Dropdown from './components/Dropdown';
import DropdownIndicator from './components/DropdownIndicator';
import ChevronDown from './components/ChevronDown';
import { useIntl } from 'react-intl';
import commonMessages from '../../../messages/common';

const selectStyles = {
  control: provided => ({
    ...provided,
    minWidth: 240,
    margin: 8,
    transition: null,
    borderRadius: null,
    borderColor: null,
    boxShadow: null,
    ...tw`sm:max-w-315 border border-primary-400 h-50 rounded`,
    '&:hover': {
      borderColor: null,
    },
  }),
  menu: () => ({
    boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)',
    ...tw`sm:max-w-315`,
  }),
  menuList: provided => ({
    ...provided,
    maxHeight: '200px',
    paddingTop: null,
    paddingBottom: null,
  }),
  option: base => ({
    ...base,
    backgroundColor: null,
    color: null,
    ...tw`flex items-center text-gray-800 cursor-pointer`,
  }),
};

const ReactSelectPopout = props => {
  const {
    options,
    autoComplete,
    dropdownIndicator,
    optionComponent,
    onChange,
    value,
    children,
  } = props;
  const [isOpen, handleOpen] = useState(false);
  const { formatMessage } = useIntl();

  const toggleOpen = useCallback(() => {
    handleOpen(prevState => !prevState);
  }, []);

  const onSelectChange = useCallback(
    // tslint:disable-next-line:no-shadowed-variable
    value => {
      toggleOpen();
      onChange(value);
    },
    [toggleOpen, onChange]
  );

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={toggleOpen}
      target={children({
        iconAfter: <ChevronDown />,
        onClick: toggleOpen,
        isSelected: isOpen,
        value: value,
      })}
    >
      <Select
        autoFocus
        backspaceRemovesValue={false}
        components={{
          DropdownIndicator: dropdownIndicator,
          IndicatorSeparator: null,
          ...(optionComponent && { Option: optionComponent }),
        }}
        controlShouldRenderValue={false}
        hideSelectedOptions={false}
        isClearable={false}
        menuIsOpen
        onChange={onSelectChange}
        options={options}
        placeholder={formatMessage(commonMessages.phoneInputCountryPlaceholder)}
        styles={selectStyles}
        tabSelectsValue={false}
        value={value}
        autoComplete={autoComplete}
      />
    </Dropdown>
  );
};

ReactSelectPopout.defaultProps = {
  autoComplete: 'off',
  dropdownIndicator: DropdownIndicator,
};

ReactSelectPopout.propTypes = {
  autoComplete: PropTypes.string,
  children: PropTypes.func,
  dropdownIndicator: PropTypes.func,
  onChange: PropTypes.func,
  optionComponent: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.string,
};

export default ReactSelectPopout;
